const config = require('../../config/default.env').default;

// API Abstraction
export default class {
  constructor({ name = '' } = {}) {
    this._name = config[name] || name;
  }

  get name() {
    return this._name;
  }

  set name(value) {
    this._name = config[value] || value;
  }

  getData = ({ endpoint = '', params = null } = {}) => axios.get(this.name + endpoint, { params });

  postData = ({ endpoint = '', payload = null } = {}) => axios.post(this.name + endpoint, payload);

  putData = ({ endpoint = '', payload = null } = {}) => axios.put(this.name + endpoint, payload);

  deleteData = ({ endpoint = '' } = {}) => axios.delete(this.name + endpoint);
}
